import { JsonRpcSigner, verifyTypedData } from 'ethers';

import { DelegatedKeyAuthorization } from '#/reduxState/delegatedKey/authorizationReducer';
import { IWallet } from '#/reduxState/wallet/walletReducer';

import {
  fixWalletSignature,
  performWithCancellationAndTimeout,
} from '../utils';

export type TypedDataSignParams = Parameters<JsonRpcSigner['signTypedData']>;

export type TypeDataSignFn = (
  ...params: TypedDataSignParams
) => Promise<string>;

export const signTypedData = async (
  wallet: IWallet,
  delegatedWallet: DelegatedKeyAuthorization | undefined,
  typedData: TypedDataSignParams
): Promise<string> => {
  const signature = await performWithCancellationAndTimeout(
    wallet,
    delegatedWallet,
    signer => {
      console.debug('Signing typed data: ', typedData);

      // Note that alternative way is to create hash from typedData and sign it,
      // but most Wallets consider that not safe (using eth_sign)
      // https://support.metamask.io/hc/en-us/articles/14764161421467-What-is-eth-sign-and-why-is-it-a-risk-
      // return (signer as JsonRpcSigner)._legacySignMessage(ethers.toBeArray(structHash));

      return signer.signTypedData(...typedData);
    }
  );
  return fixWalletSignature(signature);
};

export const recoverTypedDataSignerAddress = (
  typedData: TypedDataSignParams,
  signature: string
): string => {
  return (verifyTypedData(...typedData, signature) || '').toLowerCase();
};
